import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "NoImage"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 2.5605L21.4395 1.5L1.5 21.4395L2.5605 22.5L4.0605 21H19.5C20.3279 20.9988 20.9988 20.3279 21 19.5V4.0605L22.5 2.5605ZM19.5 19.5H5.56048L11.4052 13.6552L13.1895 15.4395C13.7752 16.0251 14.7247 16.0251 15.3105 15.4395L16.5 14.25L19.5 17.2477V19.5ZM19.5 15.126L17.5605 13.1865C16.9747 12.6009 16.0252 12.6009 15.4395 13.1865L14.25 14.376L12.4672 12.5933L19.5 5.5605V15.126ZM4.5 16.5V14.25L8.25 10.5023L9.27975 11.5328L10.3417 10.4708L9.3105 9.4395C8.72475 8.85393 7.77525 8.85393 7.1895 9.4395L4.5 12.129V4.5H16.5V3H4.5C3.67192 3.00083 3.00083 3.67192 3 4.5V16.5H4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/NoImage.vue"]]);
